import {motion} from 'framer-motion';

function FullscreenContainer({ children, delayTime }) {
  return (
    <motion.div
      className="normalContainer"
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{duration: 1, delay: delayTime}}>
        {children}
    </motion.div>
  )
}

export default FullscreenContainer